import { render, staticRenderFns } from "./matching.vue?vue&type=template&id=236faede&scoped=true"
import script from "./matching.vue?vue&type=script&lang=js"
export * from "./matching.vue?vue&type=script&lang=js"
import style0 from "./matching.vue?vue&type=style&index=0&id=236faede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236faede",
  null
  
)

export default component.exports